<template>
    <div class="wrap my invoicePage">
        <el-row :gutter="20" class="main_block">
            <div class="mianContent">
                <div class="tagView">
                    <div class="title_aside"></div>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="invoice">
                    <div class="cnt">
                        <!-- <div class="hint">
                            <h4>开票规则</h4>
                            <ul>
                                <li>
                                    1、由于纸质发票有限，建议累计开具。
                                </li>
                                <li>
                                    2、纸质发票邮寄费用：1000元以上中通快递包邮。1000元以下顺丰到付，异地大约20元左右，邮费需要您自理，如对到付的快递费金额有疑问，请向快递公司进行咨询。
                                </li>
                                <li>
                                    3、具体开票规则详情，请查看开票说明。
                                </li>
                            </ul>
                        </div> -->
                        <div class="form">
                            <el-form
                                :model="applyform"
                                :rules="rules"
                                ref="applyform"
                                label-width="180px"
                                class="demo-ruleForm"
                                label-position="left"
                            >
                                <el-form-item label="申请开票订单" label-width="180px">
                                    <div class="orderNum">
                                        {{applyform.orderIds}}
                                    </div>
                                </el-form-item>
                                <el-row :gutter="20">
                                    <el-col :span="16">
                                        <el-form-item
                                            label="发票金额(元)"
                                            prop="showAmount"
                                            label-width="180px"
                                        >
                                            <el-input
                                                :disabled="Editorial"
                                                @change="editMoney"
                                                v-model="applyform.showAmount"
                                            >
                                            </el-input>
                                            <input type="hidden" v-model="applyform.amount">
                                        </el-form-item>
                                        </el-col>
                                </el-row>
                                <el-form-item label="发票内容" label-width="180px">
                                    *生产生活服务*时间戳服务费
                                </el-form-item>
                                <el-form-item
                                    label="发票抬头"
                                    label-width="180px"
                                >
                                    <el-radio-group v-model="applyform.subjectType" @change="chooseTitle">
                                        <el-radio :label="1">企业</el-radio>
                                        <el-radio :disabled="applyform.category==4" :label="0">个人/非企业单位</el-radio>
                                    </el-radio-group>
                                    <span class="notes">（若需要报销,请选择“企业”类型）</span>
                                </el-form-item>
                                <el-form-item
                                    v-if="applyform.subjectType == 1"
                                    label-width="180px"
                                    prop="category"
                                >
                                    <span slot="label">发票类型<span style="color: #999; font-weight: normal;">（数电发票）</span></span>
                                    <el-radio-group v-model="applyform.category">
                                        <el-radio :label="3">增值税普通发票</el-radio>
                                        <el-radio :label="4">增值税专用发票</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-form>
                            <!-- 最新的企业数电发票同原来的企业电子字段 -->
                            <el-form
                                v-show="current=='EnterElectron'"
                                :model="EnterElectron"
                                :rules="rules"
                                ref="EnterElectron"
                                label-position="top"
                                class="demo-ruleForm"
                            >
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业名称" prop="subjectName">
                                            <el-autocomplete
                                                ref="companyInput"
                                                placeholder="请输入企业全称"
                                                v-model="EnterElectron.subjectName"
                                                :maxlength="100"
                                                :fetch-suggestions="queryCompany"
                                                :trigger-on-focus="false"
                                                value-key="name"
                                                @select="handleCompanySelect"
                                                @change="onCompanyNameChange"
                                                popper-class="company-suggestion"
                                                style="width: 100%"
                                            >
                                                <template slot-scope="{ item }">
                                                    <span v-html="highlight(item.name, EnterElectron.subjectName)"></span>
                                                </template>
                                                <template slot="suffix">
                                                    <b class="addTitle" @click="showEnterpriseTitleDialog">选择抬头</b>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="税号" prop="uscc">
                                            <el-input placeholder="统一社会信用代码" v-model="EnterElectron.uscc" @blur="onUsccBlur"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="接收邮箱" prop="email">
                                            <el-input placeholder="name@company.com" v-model="EnterElectron.email"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="手机号" prop="mobile">
                                            <el-input placeholder="接收开票通知" v-model="EnterElectron.mobile"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="开户银行">
                                            <el-input placeholder="选填" v-model="EnterElectron.bankName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="银行账号">
                                            <el-input placeholder="选填" v-model="EnterElectron.bankNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="公司地址">
                                            <el-input placeholder="选填，用于专票开具" v-model="EnterElectron.entAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司电话">
                                            <el-input placeholder="选填，用于专票开具" v-model="EnterElectron.entPhone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="备注">
                                    <el-input class="txt" placeholder="请输入备注信息，将显示在发票的备注栏" type="textarea" v-model="EnterElectron.invoiceRemark"></el-input>
                                </el-form-item>
                            </el-form>
                            <!-- 最新的个人数电发票同原来的个人电子字段 -->
                            <el-form
                                v-show="current=='personElectron'"
                                :model="personElectron"
                                :rules="rules"
                                ref="personElectron"
                                label-position="top"
                                class="demo-ruleForm"
                            >
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="个人/单位名称" prop="subjectName">
                                            <el-input class="add-title-input" placeholder="请输入个人/单位名称" v-model="personElectron.subjectName" :maxlength="100">
                                                <template slot="suffix">
                                                    <b class="addTitle" @click="showPersonalTitleDialog">选择抬头</b>
                                                </template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="接收邮箱" prop="email">
                                            <el-input placeholder="name@company.com" v-model="personElectron.email"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="手机号" prop="mobile">
                                            <el-input placeholder="接收开票通知" v-model="personElectron.mobile"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户银行">
                                            <el-input placeholder="选填" v-model="personElectron.bankName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="银行账号">
                                            <el-input placeholder="选填" v-model="personElectron.bankNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="地址">
                                            <el-input placeholder="选填" v-model="personElectron.entAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="电话">
                                            <el-input placeholder="选填" v-model="personElectron.entPhone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="备注">
                                    <el-input class="txt" placeholder="请输入备注信息，将显示在发票的备注栏" type="textarea" v-model="personElectron.invoiceRemark"></el-input>
                                </el-form-item>
                            </el-form>
                    
                            <div class="agreement">
                                <el-checkbox v-model="agreement" @change="read()">
                                </el-checkbox>
                                <span
                                    >本人已点击阅读并同意<b
                                        class="des"
                                        @click="invoice_account = true"
                                        >《开票说明》</b
                                    >的全部内容</span
                                >
                            </div>
                            <div class="btn">
                                <el-button
                                    @click="$route.query.id ? $router.replace({path:'/invoice/history'}) : $router.replace({path:'/invoice/apply'})"
                                >取消</el-button>
                                <el-button
                                    type="primary"
                                    @click="submitForm"
                                    >确认申请</el-button
                                >
                            </div>
                        </div>
                    </div>
                    <!-- 开票说明 -->
                    <el-dialog
                        title="开票说明"
                        :visible.sync="invoice_account"
                        width="50%"
                        :modal-append-to-body="false"
                        center
                        top="10vh"
                    >
                        <ul class="account">
                            <li class="bold">尊敬的客户：</li>
                            <li class="indent">根据《国家税务总局北京市税务局关于开展全面数字化的电子发票试点工作的公告》(国家税务总局北京市税务局公告 2023 年第3号)以及主管税务机关的要求，北京联合信任技术服务有限公司（简称“我司”）于2024年4月24日开始开具的发票升级为全面数字化的电子发票（简称“数电发票”），同时将不再提供旧版电子（纸质）普票或纸质专票。</li>
                            <li class="bold">
                                关于数电发票作如下说明:
                            </li>
                            <li>
                                1、数电发票版式全面简化，取消了发票密码区、发票代码、校验码、收款人、复核人、销售方。数电发票无联次，基本内容包括:发票号码、开票日期、购买方信息、销售方信息、项目名称、规格型号、单位、数量、单价、金额、税率/征收率、税额、合计、价税合计、备注、开票人等。
                            </li>
                            <li>
                                2、数电发票的法律效力、基本用途等与旧版纸质发票相同。
                            </li>
                            
                            <li>3、数电发票可自行打印，无需在纸质打印件上加盖发票专用章。</li>
                            <li>
                                4、数电发票不支持换开旧版的增值税电子（纸质）普票及纸质专票。
                            </li>
                            <li>
                                5、开票规则：
                            </li>
                            <li class="indent">
                                a、充值后，您可随时申请开具发票，可申请开票金额不超过实际支付金额；
                            </li>
                            <li class="indent">
                                b、如需申请重开发票，请到权利卫士app“我的-申请开票-开票历史”中申请重开；
                            </li>
                            <li>6、【信息准确性负责】请您在申请开票时，务必确保所有开票信息（特别是购买方名称、纳税人识别号）准确无误。因您填写信息错误导致的一切后果和责任，由您自行承担。</li>
                            <li>7、【红冲权利】我司有权在发现开票信息错误、涉嫌虚假或违反法律法规时，为维护税务合规性，单方面对已开具的发票执行红冲（作废）操作。</li>
                            <li>8、如申请发票遇到问题，请联系客服，客服微信二维码为：</li>
                            <li class="kefu">
                                <img src="https://evidence-public.oss-cn-beijing.aliyuncs.com/customerImages/1.png" width="131" height="131" alt="">
                            </li>
                        </ul>
                    </el-dialog>
                    <!-- 提示 -->
                    <el-dialog
                        title="提示"
                        :visible.sync="success"
                        width="40%"
                        :modal-append-to-body="false"
                        :show-close="false"
                        :close-on-press-escape="false"
                        :close-on-click-modal="false"
                        center
                    >
                        <div class="ts">
                            <h4>提交成功</h4>
                            <p>
                                可以前往
                                <span @click="goout()">开票历史</span>
                                页面查看您的开票进度
                            </p>
                            <p>
                                {{timetext}}
                            </p>
                        </div>
                    </el-dialog>
                    <!-- 选择抬头 -->
                    <InvoiceDialog
                        :visible.sync="showTitleDialog"
                        title="选择发票抬头"
                        width="560px"
                        cancelText="添加常用抬头"
                        confirmText="确定"
                        :showConfirm="titleList.length > 0"
                        footer-align="center"
                        @confirm="onTitleConfirm"
                        @cancel="onAddTitle"
                        @close="onTitleClose"
                    >
                        <div class="title-dialog-body">
                            <div style="padding-bottom: 30px;" v-if="titleList.length===0">
                                <EmptyData message="暂无发票抬头" ></EmptyData>
                            </div>
                            <div v-else class="title-list" v-infinite-scroll="loadMoreTitle" :infinite-scroll-disabled="titleLoading" :infinite-scroll-distance="10">
                                <div class="title-list-content">
                                    <div
                                        v-for="(item, index) in titleList"
                                        :key="item.id || index"
                                        class="title-item"
                                        :class="{ active: selectedTitleIndex === index }"
                                        @click="selectTitleItem(index)"
                                    >
                                        <div class="title-icon">
                                            <i :class="item.titleType === 0 ? 'el-icon-office-building' : 'el-icon-user'"></i>
                                        </div>
                                        <div class="title-info">
                                            <div class="title-name-row">
                                                <span class="title-name" :title="item.titleName">{{ item.titleName }}</span>
                                                <span class="title-tag tag-company" v-if="item.isDefault === 1">
                                                    默认
                                                </span>
                                            </div>
                                            <div class="title-sub">{{ item.titleType === 0 ? (item.taxNo || '企业抬头') : '个人抬头' }}</div>
                                        </div>
                                        <div class="title-radio">
                                            <div class="radio-circle" :class="{ checked: selectedTitleIndex === index }">
                                                <i v-if="selectedTitleIndex === index" class="el-icon-check"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="titleLoading" class="loading-text">加载中...</div>
                                    <div v-if="titleNoMore" class="no-more-text">没有更多了</div>
                                </div>
                            </div>
                        </div>
                    </InvoiceDialog>
                    <!-- 添加/编辑抬头弹窗 -->
                    <InvoiceDialog
                        :visible.sync="formDialogVisible"
                        :title="isEdit ? '编辑发票抬头' : '添加发票抬头'"
                        width="600px"
                        cancelText="取消"
                        confirmText="保存"
                        @confirm="onFormConfirm"
                        @cancel="onFormCancel"
                        @close="onFormCancel"
                    >
                        <div class="dialog-form-body">
                            <InvoiceTitleForm ref="titleForm" :data="editData" />
                        </div>
                    </InvoiceDialog>
                    
                    <InvoiceDialog :visible.sync="sendVisible" title="申请已提交" width="438px" type="simple" @confirm="onConfirm">
                        <div class="dialog-simple-body">
                            <p class="ts2">您提交的申请将由人工进行审核。释放订单后原发票将被作废，无法进行报销。</p>
                        </div>
                    </InvoiceDialog>
                </div>
            </div>
        </el-row>
    </div>
</template>

<script>
import {addInvoice,preInvoice,getInvoiceDetailById,searchByName,searchByCode,getTitleList,addTitle,editeTitle,reopen,preReopen} from "@http/invoice/index";
import {orderData} from "@http/order/index";
import InvoiceDialog from "@/components/Invoice/dialog.vue";
import InvoiceTitleForm from "@/components/Invoice/titleForm.vue";
import EmptyData from "@/components/Invoice/emptyData.vue"
var interval = null;
var searchTimer = null;
var lastQueryKeyword = '';   // 上次实际查询的关键词
var lastQueryResult = null;  // 上次查询的结果，null=未查询，[]=无结果，有数据=有结果
export default {
    data() {
        var numOrLetters=(rule, value, callback) => {
            if (!(/^[0-9A-Z]{6,20}$/.test(value))) {
                callback(new Error("请输入6-20位的数字或大写字母"));
            }
            callback();
        };
        var phone= (rule, value, callback) => {
            if(!value){
                callback();
            }
            if (!(/^1[3456789]\d{9}$/.test(value))) {
                callback(new Error("请输入正确的手机号码"));
            }
            callback();
        };
        var telPhone = (_rule, value, callback) => {
            if (!value) {
                callback();
                return;
            }
            if (!/^[\d\-]+$/.test(value)) {
                callback(new Error('仅支持输入数字和"-"'));
                return;
            }
            callback();
        };
        var space=(rule, value, callback) => {
            if (value.trim().length == 0) {
                callback(new Error("输入内容不能全为空格"));
            }
            callback();
        };
        var bankno=(rule, value, callback) => {
            if (!( /^\+?[0-9][0-9]*$/.test(value))) {
                callback(new Error("请输入正确的银行卡号"));
            }
            callback();
        };
        var iscompany=(rule, value, callback) => {
            if (!value) {
                if(this.current=='personElectron'){
                    callback(new Error("请填写个人/单位名称"));
                }else{
                    callback(new Error("请填写企业名称"));
                }
            }
            callback();
        };
        var email=(rule, value, callback) => {
            var reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
                );
            if(!value){
                callback();
            }
            if (!reg.test(value)) {
                callback(new Error("邮箱格式不正确"));
            }
            callback();
        };
        var isamount=(rule, value, callback) => {
            if (!/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(value)) {
                callback(new Error("开票金额不合法,请输入大于0的整数或两位小数"));
            }
            if(value>(this.maxAmount?this.maxAmount:this.applyform.amount)){
                callback(new Error("当前开票金额不能高于可开发票总金额"));
            }
            callback();
        };
        return {
            current:'EnterElectron',
            invoice_account: false,
            success: false,
            currentTime:'4',
            timetext:'3s',
            btndisabled: true,
            agreement: false,
            showTitleDialog: false,
            applyform: {
                type: 1,//固定传1，原来的电子票
                category: 3,
                subjectType: 1,
                expressType:2,
                orderIds:'',
                userId: parseInt(this.$getlocalStorage('userData')?.id || 0),
                sourceType:975260,
                amount: "",//选中开票总金额，固定不变。
                showAmount:'',//显示的开票金额，正常等于amount，特殊订单可被编辑。
                orderAmount:'',//始终等于amount，前端不用，接口要。
                specialAmount:'',//特殊订单就是showAmount的值。
                orderType:0,
                divideStatus:0,
            },
            //企业电子
            EnterElectron:{
                subjectName: "",
                uscc: "",
                email:'',
                mobile: "",
                bankName: "",
                bankNo: "",
                entAddress:"",
                entPhone:"",
                invoiceRemark:""
            },
            //个人电子
            personElectron:{
                subjectName: "",
                email:'',
                mobile: "",
                bankName: "",
                bankNo: "",
                entAddress:"",
                entPhone:"",
                invoiceRemark:""
            },
            
            rules: {
                type: [
                    {
                        required: true,
                        message: "请选择发票类型",
                        trigger: "change"
                    }
                ],
                category: [
                    {
                        required: true,
                        message: "请选择发票类型",
                        trigger: "change"
                    },
                    {
                        required: true,
                        message: "请选择发票类型",
                        trigger: "blur"
                    }
                ],
                showAmount: [
                    { validator: isamount, trigger: "blur" }
                ],
                amount: [
                    {
                        required: true,
                        message: "发票金额不能为空",
                        trigger: "blur"
                    },
                    { validator: space, trigger: "blur" }
                ],
                subjectType: [
                    {
                        required: true,
                        message: "请选择发票抬头",
                        trigger: "change"
                    }
                ],
                mobile: [
                    {
                        required: false,
                        message: "请输入收票人手机号",
                        trigger: "blur"
                    },
                    { validator: phone, trigger: "blur" }
                ],
                bankName: [
                    {
                        required: true,
                        message: "请填写开户银行",
                        trigger: "blur"
                    },
                    { validator: space, trigger: "blur" }
                ],
                bankNo: [
                    {
                        required: true,
                        message: "请填写银行账号",
                        trigger: "blur"
                    },
                    { validator: space, trigger: "blur" },
                    { validator: bankno, trigger: "blur" }
                ],
                province: [
                    { required: true, message: "请选择地区", trigger: "change" }
                ],
                subjectName: [
                    { validator: iscompany, trigger: "blur" },
                    { validator: space, trigger: "blur" },
                    { required: true, message: "请项为必填项", trigger: "blur" },
                    { max: 100, message: "最多输入100个字符", trigger: "blur" },
                ],
                entAddress: [
                    {
                        required: true,
                        message: "请填写公司地址",
                        trigger: "blur"
                    },
                    { validator: space, trigger: "blur" }
                ],
                entPhone:[
                    {
                        required: true,
                        message: "请填写公司电话",
                        trigger: "blur"
                    },
                    { validator: telPhone, trigger: "blur" },
                ],
                uscc: [
                    {
                        required: true,
                        message: "请填写公司税号",
                        trigger: "blur"
                    },
                    { validator: space, trigger: "blur" },
                    { validator: numOrLetters, trigger: "blur" },
                    { min:6, max: 20, message: '请输入6-20位的数字或大写字母', trigger: 'blur' }
                ],
                email:[
                    {
                        required: false,
                        message: "请填写邮箱",
                        trigger: "change"
                    },
                    { validator: email, trigger: "blur" }
                ]
            },
            redirect:'',
            disabled:false,
            Editorial:true,
            maxAmount:'',
            orderList:[],
            titleList:[],
            selectedTitleIndex: -1,
            titleLoading: false,
            titleNoMore: false,
            titlePage: 1,
            titleTotal: 0,
            formDialogVisible: false,
            isEdit: false,
            editData: {},
            defaultEnterpriseTitle: null, // 默认企业抬头
            defaultPersonalTitle: null, // 默认个人抬头
            currentTitleType: 0, // 当前选择的抬头类型：0企业，1个人
            sendVisible:false,
            originalData: null, // 保存原始发票数据用于对比
        };
    },

    components: { InvoiceDialog, InvoiceTitleForm, EmptyData},

    computed: {
        disable(){
            if((this.applyform.showAmount)<5000){
                this.disabled=true;
            }else{
                this.disabled=false;
            }
            return this.disabled;
        },
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },

    async created() {
        let orderObj = JSON.parse(sessionStorage.getItem('orderObj'));
        if(this.$route.query.id && !orderObj){
            try {
                let formData=await getInvoiceDetailById(this.$route.query.id)
                this.applyform=formData;
                // 根据抬头类型赋值对应表单：1企业->EnterElectron，0个人->personElectron
                if (formData.subjectType === 1) {
                    this.current='EnterElectron';
                    this.EnterElectron = formData;
                } else {
                    this.current='personElectron';
                    this.personElectron = formData;
                }
                this.applyform.showAmount=formData.amount;
                this.applyform.type=1;
                // 老数据category可能为1等旧值，不是3或4则置空，提交时提示重新选择
                if (![3, 4].includes(formData.category)) {
                    this.applyform.category = '';
                }
                // 保存原始数据快照，用于提交时对比
                this.originalData = JSON.parse(JSON.stringify({
                    applyform: { ...this.applyform },
                    EnterElectron: { ...this.EnterElectron },
                    personElectron: { ...this.personElectron },
                }));
            } catch (error) {
                console.log(error)
                this.$router.replace({
                    path:'/invoice/history'
                })
                //this.$msg(error.message,'error')
            }
            return
        }
        this.orderList = orderObj.orderList;
        let orderIds='';
        let amount=0;
        this.orderList.map((item,index)=>{
            if(index==(this.orderList.length-1)){
                orderIds=orderIds+item.orderId
            }else{
                orderIds=orderIds+item.orderId+','
            }
            amount=amount+item.orderAmount;
        })
        this.applyform.orderType=this.orderList[0].orderType;
        this.applyform.orderIds=orderIds;
        this.applyform.amount=amount;
        this.applyform.showAmount=parseFloat(amount).toFixed(2);
        this.applyform.expressType=amount<1000?1:2;

        if(orderIds.indexOf(',')==-1){
            let res = await orderData({
                page: 1,
                size: 10,
                invoiceStatus: ['1'],
                orderId: orderIds,
            });
            if(res?.data.length>0){
                if(res.data[0].suiteId&&res.data[0].suiteId==8){
                    this.Editorial=false;
                    this.maxAmount=res.data[0].invoiceAmount;
                    this.applyform.amount=res.data[0].invoiceAmount.toFixed(2)
                    this.applyform.showAmount=res.data[0].invoiceAmount.toFixed(2)
                }
            }
        }

        // 加载默认抬头
        this.loadDefaultTitles();
    },

    mounted() {
        
    },

    methods: {
        read() {
            this.btndisabled = !this.agreement;
        },
        isDataUnchanged(dataObj) {
            const orig = this.originalData;
            if (!orig) return false;
            // 对比关键字段
            const fields = ['subjectName', 'uscc', 'email', 'mobile', 'bankName', 'bankNo', 'entAddress', 'entPhone', 'invoiceRemark', 'subjectType', 'category', 'showAmount', 'amount'];
            for (const key of fields) {
                if (String(dataObj[key] || '') !== String(orig.applyform[key] || '')) {
                    return false;
                }
            }
            return true;
        },
        submitForm() {
            if (!this.agreement) {
                this.$msg('请先阅读《开票说明》并勾选');
                return;
            }
            // 检查备注中的违规词
            const remark = this[this.current].invoiceRemark;
            if (remark) {
                const forbiddenWords = ['微信', '私聊'];
                for (const word of forbiddenWords) {
                    if (remark.includes(word)) {
                        this.$msg(`备注信息中包含违规词"${word}"`);
                        return;
                    }
                }
            }
            this.$refs.applyform.validate(valid1 => {
                if (!valid1) {
                    if (this.applyform.subjectType === 1 && !this.applyform.category) {
                        this.$msg('请选择发票类型');
                    }
                    return;
                }
                this.$refs[this.current].validate( async valid => {
                    if (valid) {
                        // console.log(this.applyform);
                        // console.log(this[`${this.current}`]);
                        if(!this.Editorial){//特殊订单
                            this.applyform.specialAmount=this.applyform.showAmount;
                        }else{
                            delete this.applyform.specialAmount;
                        }
                        //邮箱和电话必须填其中一个，都不填提示
                        if(!this[`${this.current}`].email && !this[`${this.current}`].mobile){
                            this.$msg('请填写接收邮箱或手机号')
                            return
                        }
                        let dataObj = Object.assign({}, this.applyform, this[this.current]);
                        if(!dataObj.id){
                            dataObj.orderAmount=dataObj.amount;
                        }
                        if(dataObj.subjectType==0){ //个人
                            dataObj.category=3;
                            delete dataObj.uscc; // 个人不提交税号
                            if(dataObj.type==1){//电子
                                delete dataObj.expressType;
                            }
                        }else{ //企业
                            if(dataObj.type==1){//电子，0纸质不用delete
                                delete dataObj.expressType;
                            }
                        }
                        if(!dataObj.id){
                            try {
                                let res1 = await preInvoice(dataObj);
                                dataObj.signature=res1.signature;
                                await addInvoice(dataObj);
                                this.success=true;
                                this.gettime();
                            } catch (error) {
                                console.log(error)
                            }
                        }else{
                            // 对比当前数据与原始数据是否一致
                            if (this.originalData && this.isDataUnchanged(dataObj)) {
                                this.$msg('所填写信息与原发票相同，请检查输入内容。');
                                return;
                            }
                            try {
                                await preReopen(dataObj.id)
                                await reopen({...dataObj , reopenType: 1})
                                this.sendVisible=true;
                            } catch (error) {
                                console.log(error)
                                // that.$msg(error.message, "error");
                            }
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            });
        },
        gettime(){
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function () {
                currentTime--;
                that.timetext=currentTime + 's'
                if (currentTime <= 0) {
                    clearInterval(interval)
                    that.success=false;
                    that.$router.push({
                        path:'/invoice/history',
                    })
                }
            }, 1000)
        },
        goout(){
            clearInterval(interval);
            this.$router.push({
                path:'/invoice/history',
            }) 
        },
        chooseTitle(val){
            this.$refs[this.current].clearValidate();
            if(val==0){ //个人
                this.current='personElectron';
                //增值税变为默认普通票
                this.applyform.category=3;
                // 如果有默认个人抬头，回显信息
                if (this.defaultPersonalTitle) {
                    this.personElectron.subjectName = this.personElectron.subjectName || this.defaultPersonalTitle.titleName || '';
                }
            }else{ //企业
                this.current='EnterElectron';
                // 如果有默认企业抬头，回显信息
                if (this.defaultEnterpriseTitle) {
                    this.EnterElectron.subjectName = this.EnterElectron.subjectName || this.defaultEnterpriseTitle.titleName || '';
                    this.EnterElectron.uscc = this.EnterElectron.uscc || this.defaultEnterpriseTitle.taxNo || '';
                }
            }
        },
        async loadDefaultTitles() {
            try {
                const res = await getTitleList({ page: 1, size: 100 });
                const list = res.data || [];
                // 查找默认的企业抬头和个人抬头
                this.defaultEnterpriseTitle = list.find(item => item.isDefault === 1 && item.titleType === 0) || null;
                this.defaultPersonalTitle = list.find(item => item.isDefault === 1 && item.titleType === 1) || null;

                // 如果有默认企业抬头，自动回显
                if (this.defaultEnterpriseTitle && this.applyform.subjectType === 1) {
                    this.EnterElectron.subjectName = this.defaultEnterpriseTitle.titleName || '';
                    this.EnterElectron.uscc = this.defaultEnterpriseTitle.taxNo || '';
                }
                // 如果有默认个人抬头，且当前是个人类型，自动回显
                if (this.defaultPersonalTitle && this.applyform.subjectType === 0) {
                    this.personElectron.subjectName = this.defaultPersonalTitle.titleName || '';
                }
            } catch (e) {
                console.error('加载默认抬头失败:', e);
            }
        },
        editMoney(val){
            if(val<1000){
                this.applyform.expressType=1
            }
        },
        queryCompany(queryString, cb) {
            clearTimeout(searchTimer);
            if (queryString.length < 4) {
                cb([]);
                return;
            }

            // 如果上次查询无结果，且当前输入包含上次查询关键词，则跳过查询
            if (lastQueryResult && lastQueryResult.length === 0 &&
                queryString.includes(lastQueryKeyword) &&
                queryString.length > lastQueryKeyword.length) {
                cb([]);
                return;
            }

            // 如果查询字符串超过50个字符，截取前50个字符进行查询
            const searchKeyword = queryString.length > 50 ? queryString.substring(0, 50) : queryString;
            searchTimer = setTimeout(async () => {
                try {
                    const res = await searchByName({ keyword: searchKeyword });
                    const list = (res || []).slice(0, 4).map(item => ({
                        ...item,
                        value: item.name || ''
                    }));
                    // 记录查询状态
                    lastQueryKeyword = queryString;
                    lastQueryResult = list;
                    cb(list);
                } catch (e) {
                    console.error('查询失败:', e);
                    cb([]);
                }
            }, 300);
        },
        async handleCompanySelect(item) {
            this.EnterElectron.subjectName = item.name;
            if (item.code) {
                try {
                    const res = await searchByCode({ code: item.code });
                    if (res && res.taxNo) {
                        this.EnterElectron.uscc = res.taxNo;
                    }
                    // 税号设置完成后再触发校验
                    this.$nextTick(() => {
                        this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('subjectName');
                        this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('uscc');
                    });
                } catch (e) {
                    console.error('查询税号失败:', e);
                }
            }
        },
        onCompanyNameChange() {
            // 企业名称改变时重新校验企业名称字段（税号由handleCompanySelect获取后单独校验）
            this.$nextTick(() => {
                this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('subjectName');
            });
        },
        onUsccBlur() {
            // 税号改变时重新校验税号字段
            this.$nextTick(() => {
                this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('uscc');
            });
        },
        highlight(text, keyword) {
            if (!keyword || !text) return text;
            const reg = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
            return text.replace(reg, `<span style="color: #0052FF; font-weight: bold;">${keyword}</span>`);
        },
        selectTitleItem(index) {
            this.selectedTitleIndex = index;
        },
        async loadTitleList() {
            this.titleLoading = true;
            this.titleNoMore = false;
            this.titlePage = 1;
            this.titleList = [];
            try {
                // 根据当前选择的发票类型过滤：1企业->titleType=0(公司)，0个人->titleType=1(个人)
                const titleType = this.applyform.subjectType === 1 ? 0 : 1;
                const res = await getTitleList({ page: 1, size: 10, titleType });
                this.titleList = res.data || [];
                this.titleTotal = res.total || 0;
                this.titleNoMore = this.titleList.length >= this.titleTotal;
            } catch (e) {
                console.error('加载抬头列表失败:', e);
            }
            this.titleLoading = false;
        },
        async loadMoreTitle() {
            if (this.titleLoading || this.titleNoMore) return;
            this.titleLoading = true;
            this.titlePage++;
            try {
                const titleType = this.applyform.subjectType === 1 ? 0 : 1;
                const res = await getTitleList({ page: this.titlePage, size: 10, titleType });
                const list = res.data || [];
                this.titleList = this.titleList.concat(list);
                this.titleNoMore = this.titleList.length >= this.titleTotal;
            } catch (e) {
                console.error('加载更多抬头失败:', e);
            }
            this.titleLoading = false;
        },
        onTitleConfirm() {
            if (this.selectedTitleIndex < 0) {
                this.$msg('请选择一个抬头');
                return;
            }
            const item = this.titleList[this.selectedTitleIndex];
            // 根据当前选择的抬头类型回显到不同的表单
            if (this.currentTitleType === 0) {
                // 企业抬头
                this.EnterElectron.subjectName = item.titleName;
                if (item.taxNo) this.EnterElectron.uscc = item.taxNo;
                if (item.address) this.EnterElectron.entAddress = item.address;
                if (item.phone) this.EnterElectron.entPhone = item.phone;
                if (item.bankName) this.EnterElectron.bankName = item.bankName;
                if (item.bankNo) this.EnterElectron.bankNo = item.bankNo;
            } else {
                // 个人抬头
                this.personElectron.subjectName = item.titleName;
                if (item.address) this.personElectron.entAddress = item.address;
                if (item.phone) this.personElectron.entPhone = item.phone;
                if (item.bankName) this.personElectron.bankName = item.bankName;
                if (item.bankNo) this.personElectron.bankNo = item.bankNo;
            }
            this.showTitleDialog = false;
            // 选择抬头后重新校验企业名称和税号字段
            this.$nextTick(() => {
                if (this.currentTitleType === 0) {
                    this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('subjectName');
                    this.$refs.EnterElectron && this.$refs.EnterElectron.validateField('uscc');
                } else {
                    this.$refs.personElectron && this.$refs.personElectron.validateField('subjectName');
                }
            });
        },
        showEnterpriseTitleDialog() {
            this.currentTitleType = 0;
            this.showTitleDialog = true;
        },
        showPersonalTitleDialog() {
            this.currentTitleType = 1;
            this.showTitleDialog = true;
        },
        onAddTitle() {
            this.isEdit = false;
            this.editData = {};
            this.formDialogVisible = true;
        },
        onTitleClose() {
            this.selectedTitleIndex = -1;
        },
        onFormConfirm() {
            this.$refs.titleForm.validate().then((formData) => {
                const api = this.isEdit ? editeTitle : addTitle;
                api(formData).then(() => {
                    this.$msg(this.isEdit ? '编辑成功' : '添加成功', 'success');
                    this.formDialogVisible = false;
                    this.showTitleDialog = false;
                    this.$nextTick(() => {
                        this.showTitleDialog = true;
                        this.loadTitleList();
                    });
                }).catch((err) => {
                    console.log(err);
                });
            }).catch(() => {});
        },
        onFormCancel() {
            this.formDialogVisible = false;
            this.$refs.titleForm.resetForm();
        },
        onConfirm(){
            this.sendVisible=false
            this.$router.push({
                path:'/invoice/history',
            })
        },
    },

    watch: {
        showTitleDialog(val) {
            if (val) {
                this.loadTitleList();
            }
        }
    },

    beforeDestroy() {
        sessionStorage.removeItem('orderObj');
    }
};
</script>

<style lang="less" scoped>
.my {
    padding: 0;

    .title {
        line-height: 48px;
        width: 100%;
        height: 48px;
        box-sizing: border-box;
        color: #0052FF;
        border-bottom: 1px solid #e4e9f0;

        span {
            float: left;
            width: 115px;
            height: 46px;
            text-align: center;
            font-size: 14px;
            display: block;
            border-bottom: 3px solid #0052FF;
        }

        b {
            width: 115px;
            height: 48px;
            text-align: center;
            font-size: 14px;
            display: block;
            float: right;
        }
    }

    .cnt {
        width: 100%;
        padding: 12px 32px 27px;
        box-sizing: border-box;

        .hint {
            border: 1px solid rgba(254, 225, 190, 1);
            background: rgba(255, 244, 228, 1);
            border-radius: 4px;
            padding: 11px;
            color: #ff6600;
            font-size: 14px;

            ul {
                padding: 10px 14px 0;
                font-size: 12px;

                li {
                    line-height: 20px;
                }
            }
        }

        .form {
            width: 830px;
            margin: 0 auto;
            margin-top: 30px;
        }

        .orderNum {
            word-break: break-all;
        }

        .btn {
            display: flex;
            justify-content: flex-end;
            gap: 16px;

            ::v-deep .el-button--primary {
                width: 110px;
                height: 50px;
                background: linear-gradient(153deg, #0052FF 0%, #4D7CFF 100%);
                box-shadow: 0px 4px 14px 0px rgba(0, 82, 255, 0.25);
                border-radius: 14px;
                border: 1px solid rgba(0, 0, 0, 0);
                font-size: 15px;
                font-weight: bold;

                &:hover {
                    opacity: 0.9;
                }

                &:active {
                    opacity: 0.8;
                }
            }

            ::v-deep .el-button--default {
                width: 110px;
                height: 50px;
                background: #fff;
                border: 1px solid #dcdfe6;
                border-radius: 14px;
                font-size: 15px;
                font-weight: bold;
                color: #606266;

                &:hover {
                    color: #0052FF;
                    border-color: #0052FF;
                }
            }
        }

        .agreement {
            text-align: right;
            font-size: 14px;
            margin: 27px 0;
            color: #7d7d7d;
            cursor: pointer;

            span {
                margin-left: 5px;
            }
        }

        .account {
            color: #7d7d7d;
            font-size: 14px;

            li {
                line-height: 25px;

                &.bold {
                    font-weight: bold;
                    color: #333;
                }

                &.indent {
                    text-indent: 2em;
                }
            }
        }

        

        .des {
            color: #0052FF;
        }

        .notes {
            color: #ff6600;
        }
    }
    .ts2{
        font-size: 14px;
        text-align: left;
    }
    .ts {
        padding: 35px 0;

        h4 {
            text-align: center;
            font-size: 20px;
            color: #333;
        }

        p {
            font-size: 14px;
            color: #7d7d7d;
            text-align: center;
            margin-top: 20px;

            span {
                color: #0052FF;
                cursor: pointer;
            }
        }
    }
    .addTitle{
        color: #0052FF;
        cursor: pointer;
        padding: 0 10px;
        font-weight: bold;
    }
    .dialog-form-body {
        padding: 24px 28px;
    }
    .title-list {
        max-height: 360px;
        overflow-y: auto;
        padding: 0 4px;
        .title-list-content{
            padding:10px;
        }
    }
    .title-item {
        display: flex;
        align-items: center;
        padding: 16px;
        border: 1px solid #e4e7ed;
        border-radius: 14px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all 0.2s;

        &:last-child {
            margin-bottom: 0;
        }

        &.active {
            border-color: #0052FF;
            background: rgba(0, 82, 255, 0.04);
        }

        .title-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            background: linear-gradient( 90deg, rgba(0,82,255,0.15) 0%, rgba(77,124,255,0.1) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 14px;
            flex-shrink: 0;

            i {
                font-size: 18px;
                color: #0052FF;
            }
        }

        .title-info {
            flex: 1;
            min-width: 0;

            .title-name-row {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 4px;

                .title-name {
                    font-size: 15px;
                    font-weight: bold;
                    color: #0F172A;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .title-tag {
                    font-size: 12px;
                    padding: 2px 8px;
                    border-radius: 4px;
                    flex-shrink: 0;
                    border-radius: 10px;
                }

                .tag-company {
                    background: #EEF2FF;
                    color: #0052FF;
                }

                .tag-person {
                    background: #F0F0F0;
                    color: #909399;
                }
            }

            .title-sub {
                font-size: 13px;
                color: #909399;
            }
        }

        .title-radio {
            flex-shrink: 0;
            margin-left: 12px;

            .radio-circle {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                border: 2px solid #dcdfe6;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s;

                &.checked {
                    box-sizing: border-box;
                    border-color: #0052FF;
                    background: linear-gradient( 153deg, #0052FF 0%, #4D7CFF 100%);
                    i {
                        color: #fff;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .loading-text, .no-more-text {
        text-align: center;
        padding: 12px;
        font-size: 13px;
        color: #909399;
    }
}
</style>

<style lang="less" scope>
.el-cascader {
    width: 100% !important;
}

.el-autocomplete {
    width: 100% !important;
}

.company-suggestion {
    .el-autocomplete-suggestion__list {
        li {
            height: 48px;
            line-height: 48px;
            padding: 0 16px;
            border-bottom: 1px solid #e4e7ed;
            box-sizing: border-box;

            &:last-child {
                border-bottom: none;
            }
        }
    }
}

.my {
    .el-dialog {
        border-radius: 4px;
    }

    .el-dialog__header {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 10px;
        background: #0052FF;
    }

    .el-dialog__title {
        color: #fff;
    }

    .el-dialog__headerbtn {
        top: 10px;
        font-size: 20px;

        .el-dialog__close {
            color: #fff;
        }
    }
}

.txt {
    .el-textarea__inner {
        font-family: Arial, Helvetica, sans-serif !important;
    }
}

.kefu {
    margin-top: 20px;
    text-align: center;
}

.invoicePage {
    .el-input__inner {
        height: 40px;
    }

    .el-autocomplete {
        .el-input__inner {
            padding-right: 80px;
        }
    }

    .add-title-input {
        .el-input__inner {
            padding-right: 80px;
        }
    }

    .el-form-item {
        margin-bottom: 15px;

        .el-form-item__label {
            padding: 0;
            color: #0F172A;
            font-size: 14px;
            font-weight: bold;
        }

        .el-form-item__content {
            font-size: 15px;
            color: #0F172A;
            font-weight: bold;

            .el-radio__label {
                font-size: 15px;
                color: #0F172A;
                font-weight: bold;
            }

            .el-radio__input.is-checked {
                .el-radio__inner {
                    border-color: #0052FF;
                    background: #0052FF;
                }

                + .el-radio__label {
                    color: #0052FF;
                }
            }
        }
    }
}
</style>
